export default __webpack_public_path__ + "static/media/Ballad_Health_Logo.ae3b6c06.png";